//https://transform.tools/css-to-js
export default (props: { isDarkMode: boolean }) => {
  const tableBorderColor = props.isDarkMode ? '#f5f5f9' : '#232121';
  const blockBackgroundColor = props.isDarkMode ? '#f5f5f9' : '#232121';
  const blockTextColor = props.isDarkMode ? '#232121' : '#f5f5f9';

  return {
    table: {
      ['borderCollapse' as never]: 'collapse',
      marginBottom: '0 !important',
      width: '100%',
      'thead, th': {
        ['breakAfter' as never]: 'avoid !important'
      },
      'thead, tbody, tfoot': {
        tr: {
          borderTop: `${tableBorderColor} 1px solid`,
          borderColor: `${tableBorderColor}  !important`,
          ['wordBreak' as never]: 'normal',
          ['overflowWrap' as never]: 'anywhere',

          '> td': {
            padding: '0.75rem',
            borderColor: `${tableBorderColor}  !important`,
            borderTop: 'inherit',
            verticalAlign: 'middle',
            background: 'transparent !important'
          },
          '> th, > td:not(:first-child)': {
            borderColor: `${tableBorderColor} !important`,
            borderLeft: `${tableBorderColor} 1px solid`,
            ['wordBreak' as never]: 'normal',
            ['overflowWrap' as never]: 'anywhere'
          },
          ':last-child': {
            borderColor: `${tableBorderColor}  !important`,
            borderBottom: `${tableBorderColor} 1px solid`
          },
          '> td.dark': {
            backgroundColor: `${blockBackgroundColor}  !important`,
            borderColor: `${tableBorderColor}  !important`,
            color: blockTextColor,
            ['textTransform' as any]: 'uppercase',
            verticalAlign: 'middle'
          },
          ul: { marginBottom: '0' }
        },
        // table-list is used for creating ul/li looking lists but with each element in a separate row
        // this enables better page-break handling in PDF
        'tr.table-list': {
          ':not(:last-child)': { td: { paddingBottom: '6px' } },
          ':not(:first-child)': {
            borderTopWidth: '0',
            td: { borderTopWidth: '0', paddingTop: '6px' }
          }
        }
      },
      'thead th, tbody th': {
        backgroundColor: `${blockBackgroundColor} !important`,
        '&, span': {
          color: `${blockTextColor} !important`
        },
        ['textTransform' as never]: 'uppercase',
        borderColor: `${tableBorderColor} !important`,
        borderTop: `${tableBorderColor} 1.5px solid`,
        borderBottom: `${tableBorderColor} 1.5px solid`,
        padding: '6px',
        ['textAlign' as never]: 'left'
      },
      '&.no-border': { 'tr, td': { border: 'none !important' } }
    },
    'table.compact, .ant-table-wrapper.compact': {
      th: {},
      td: { padding: '0.25rem' },
      'th.instances': { width: '100px', maxWidth: '100px' },
      marginTop: '0px'
    },
    '.ant-table': { background: 'transparent !important' },
    '.environment-section-table': {
      marginTop: '0px',
      marginBottom: '0px',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '> table': {
        ['breakInside' as any]: 'avoid',
        ['breakAfter' as any]: 'auto',
        '> thead': {
          ['breakAfter' as any]: 'avoid'
        },
        '> tbody > tr': {
          ['breakInside' as any]: 'avoid', // Keep individual rows together
          ['breakAfter' as any]: 'auto' // Allow breaks between rows if needed
        }
      },
      '> .threat-exposure-block-table': { ['breakInside' as any]: 'avoid' }
    },
    thead: {
      backgroundColor: `${blockBackgroundColor} !important`
    }
  };
};
